import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, computed, onBeforeMount, toRef } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { validatePassword } from '@/utils/validator'
import AuthService from '@/services'
import { RequestGeneratePassword } from '@/models'
import TextField from '@/components/TextField.vue'
import PageTitle from '@/components/PageTitle.vue'
import { AlphaButtonAv } from '@op-frontend/vue2tifywind';


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneratePassword',
  props: {
	userId: {
		type: String,
		required: true
	}
},
  setup(__props) {

const props = __props;

const { t } = useI18n()



const userId = toRef(props, 'userId')

const form: RequestGeneratePassword = reactive<RequestGeneratePassword>({
	password: '',
	confirmPassword: ''
})
const errors = reactive<Record<string, string>>({
	password: '',
	confirmPassword: ''
})
const isErrorPassword = computed<boolean>(() => !!errors.password)
const isErrorConfirmPassword = computed<boolean>(() => !!errors.confirmPassword)
const guestUserEmail = ref<string>('')

onBeforeMount(async () => {
	guestUserEmail.value = await AuthService.getGuestUserDetails(userId.value)
})

const supportUrl =
	'https://support.achilles.id/hc/umum/bagaimana-kalau-saya-lupa-kata-kunci-password-akun-di-onlinepajak'

const validateForm = () => {
	if (!form.password.length) errors.password = 'errors.password__required'
	else if (!validatePassword(form.password)) errors.password = 'errors.password__invalid-length'
	else errors.password = ''

	if (form.password !== form.confirmPassword)
		errors.confirmPassword = 'errors.confirm-password__mismatch'
	else errors.confirmPassword = ''
}

const setPassword = (val: string) => {
	form.password = val
	validateForm()
}

const setConfirmPassword = (val: string) => {
	form.confirmPassword = val
	validateForm()
}

const generatePasswordAction = async () => {
	validateForm()

	if (!isErrorPassword.value && !isErrorConfirmPassword.value) {
		const response = await AuthService.savePasswordAndLogin({
			userId: userId.value,
			password: form.password,
			confirmPassword: form.confirmPassword
		})

		if (response !== null) window.location.href = response
	}
}

return { __sfc: true,t, props, userId, form, errors, isErrorPassword, isErrorConfirmPassword, guestUserEmail, supportUrl, validateForm, setPassword, setConfirmPassword, generatePasswordAction, TextField, PageTitle, AlphaButtonAv }
}

})